export class Report {
  Date: Date;
  Hour: number;
  JoinType: string;
  Account: string;
  Campaign: string;
  CampaignId: string;
  Partner: string;
  Device: string;
  Cost: number;
  Value: number;
  Margin: number;
  MarginPer: number;
  Clicks: number;
  Impressions: number;
  AvgPosition: number;
  AvgCPC: number;
  Leads: number;
  CostPerLead: number;
}
export class BigData {
  topLevel: Report[];
  detail:Report[]
  constructor() {
    this.topLevel = [];
    this.detail = [];
  }
}
export class Sort {
  column: string;
  isDesc: boolean;
  accFilter: string;
  joinFilter: string;
  camFilter: string;
  camParFilter: string;
  camIdFilter: string;
  camDevFilter: string;
  constructor() {
    this.column = 'Cost';
    this.isDesc = false;
    this.camParFilter = "All";
    this.accFilter = "All";
    this.joinFilter = "All";
    this.camFilter = "";
    this.camIdFilter = "";
    this.camDevFilter = "All";
  }
}
export class Summary {
  records: number;
  totalValue: number;
  totalCost: number;
  totalMargin: number;
  totalPercent: number;
  totalClicks: number;
  totalImpressions: number;
  avgPos: number;
  avgCPC: number;
  totalLeads: number;
  totalCostPerLead: number;

  constructor() {

      this.avgCPC = 0;
      this.avgPos = 0;
      this.records = 0;
      this.totalClicks = 0;
      this.totalCost = 0;
      this.totalImpressions = 0;
      this.totalMargin = 0;
      this.totalPercent = 0;
      this.totalValue = 0;
      this.totalLeads = 0;
      this.totalCostPerLead = 0;

  }

}



// WEBPACK FOOTER //
// E:/Release/InzuzoA/InzuzoA/src/app/_models/report.ts